import React, { useEffect, useState } from "react";
import {
  Container,
  Tab,
  Tabs,
  Card,
  Row,
  Col,
  Button,
  Spinner
} from "react-bootstrap";
import Palette from "../../Palette";
import Member from "../../models/Member";
import { Link } from "react-router-dom";

export default function MitraListPage() {
  const [activeTab, setActiveTab] = useState("universities");
  const [mitraSwastaData, setMitraSwastaData] = useState([])
  const [isLoading, setLoading] = useState(false);
  let isLoggedIn = !!localStorage.getItem('user')
  const memberModel = new Member()
  const fetchListActiveMitra = async () => {
    try {
      setLoading(true)
      const result = await memberModel.getMitraSwastaActive()
      setMitraSwastaData(result || [])
    } catch (err) {
      console.log('fetchListActiveMitra err', err)
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    fetchListActiveMitra()
  }, [])




  return (
    <Container className="py-4">
      {/* Judul Utama */}
      <h2
        className="text-center fw-bold mb-3"
        style={{ color: Palette.PRIMARY }}
      >
        HPI dan Para Mitra
      </h2>

      {/* Deskripsi */}
      <p
        className="mx-auto mb-5"
        style={{ maxWidth: "800px", textAlign: "justify" }}
      >
        HPI sebagai asosiasi profesi penerjemah dan juru bahasa Indonesia
        berkomitmen menciptakan ekosistem industri yang sehat guna mewujudkan
        visi sebagai organisasi yang Profesional, Tepercaya, dan Terhormat.
        Dalam kemitraannya, HPI berfokus pada pendidikan—dengan menggandeng
        universitas untuk seminar, pelatihan, magang, dan Uji Kemahiran
        Penerjemahan—serta regulasi, melalui keterlibatannya dalam penyusunan
        kebijakan pemerintah terkait standar kompetensi, kualifikasi, dan tata
        bahasa Indonesia.
      </p>

      {/* Judul List */}
      <h2 className="text-center fw-bold mb-5" style={{ color: "#000" }}>
        {/* List Mitra */}
        Mitra Swasta Terdaftar
      </h2>

      <Card className="mb-5 shadow-sm border-0">
        <Card.Body>
          {isLoading ? (
            <Spinner
              animation="border"
              size={'sm'}
              style={{
                color: 'white',
                marginBottom: 3,
                marginRight: 7
              }}
            />
          ) : (
            <Row>
              {mitraSwastaData?.map((mitraData, i) => (
                <Col lg={3} md={4} sm={6} xs={12} className="mb-4" key={i}>
                  <Link to={`/mitra-swasta/${mitraData.id}`}>
                    <Card className="h-100 shadow-sm text-center border-0">
                      <div
                        className="d-flex align-items-center justify-content-center"
                        style={{
                          height: "150px",
                          background: "#f8f9fa",
                          borderBottom: "1px solid #ddd",
                          overflow: "hidden",
                        }}
                      >

                        <img
                          onError={(e) => {
                            e.currentTarget.onerror = null;
                            e.currentTarget.src = '/no-image-placeholder.jpg';
                          }}
                          src={mitraData.profile_picture_url || '/no-image-placeholder.jpg'}
                          alt={mitraData.full_name}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                          }}
                        />

                      </div>
                      <Card.Body>
                        <Card.Text className="fw-semibold">{mitraData.full_name}</Card.Text>
                      </Card.Body>
                    </Card>
                  </Link>

                </Col>
              ))}
            </Row>
          )}
        </Card.Body>
      </Card>


      {/* ======== Banner CTA Paling Bawah ======== */}
      {
        !isLoggedIn && (
          <>
            <Card className="border-0 shadow-sm rounded-3 p-4 mt-5">
              <Row className="align-items-center">
                <Col md={8} className="mb-3 mb-md-0">
                  <h4 className="fw-bold mb-2">Ingin menjalin kemitraan dengan HPI?</h4>
                  <p className="mb-0">
                    Jalin kemitraan strategis bersama HPI untuk turut mengembangkan
                    kualitas pendidikan dan regulasi di bidang penerjemahan.
                  </p>
                </Col>
                <Col md={4} className="text-md-end text-center">
                  <Button
                    style={{
                      backgroundColor: Palette.PRIMARY || "blue",
                      border: "none",
                      padding: "10px 24px",
                      borderRadius: "8px",
                    }}
                    href="/mitra-swasta/register"
                  >
                    Daftar Jadi Mitra
                  </Button>
                </Col>
              </Row>
            </Card>
          </>
        )
      }


      {/* Custom CSS */}
      <style>{`
        .custom-tabs .nav-item {
          flex: 1;
          text-align: center;
        }
        .custom-tabs .nav-link {
          border: none !important;
          border-bottom: 2px solid #dee2e6;
          color: #555;
          background: transparent !important;
          padding: 10px 0;
        }
        .custom-tabs .nav-link.active {
          border: none !important;
          border-bottom: 2px solid #dee2e6;
          font-weight: 600;
          color: ${Palette.PRIMARY} !important;
          background: transparent !important;
        }
      `}</style>
    </Container>
  );
}
